import React from "react";
import PropTypes from "prop-types";
import { Label, Input, FormFeedback, TabPane } from "reactstrap";
import CountrySelect from "../../../Components/Common/CountrySelect";

const LegalClientForm = ({
  activeArrowTab,
  validation,
  handleNext,
  toggleArrowTab,
}) => {
  // Tab 1 - Company Details
  const renderCompanyDetailsTab = () => (
    <TabPane id="steparrow-gen-info" tabId={1}>
      <div>
        <div className="row gy-4 mb-3">
          <div className="col-md-6">
            <Label htmlFor="legal_company_name-field" className="form-label">
              Legal Company Name
            </Label>
            <Input
              name="legal_company_name"
              id="legal_company_name-field"
              className="form-control"
              placeholder="Enter Legal Company Name"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.legal_company_name || ""}
              invalid={
                validation.touched.legal_company_name &&
                validation.errors.legal_company_name
                  ? true
                  : false
              }
            />
            {validation.touched.legal_company_name &&
              validation.errors.legal_company_name && (
                <FormFeedback type="invalid">
                  {validation.errors.legal_company_name}
                </FormFeedback>
              )}
          </div>

          <div className="col-md-6">
            <Label htmlFor="legal_fiscal_code-field" className="form-label">
              Legal Fiscal Code
            </Label>
            <Input
              name="legal_fiscal_code"
              id="legal_fiscal_code-field"
              className="form-control"
              placeholder="Enter Legal Fiscal Code"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.legal_fiscal_code || ""}
              invalid={
                validation.touched.legal_fiscal_code &&
                validation.errors.legal_fiscal_code
                  ? true
                  : false
              }
            />
            {validation.touched.legal_fiscal_code &&
              validation.errors.legal_fiscal_code && (
                <FormFeedback type="invalid">
                  {validation.errors.legal_fiscal_code}
                </FormFeedback>
              )}
          </div>
        </div>

        <div className="row gy-4 mb-3">
          <div className="col-md-6">
            <Label
              htmlFor="legal_unique_registration_code-field"
              className="form-label"
            >
              Unique Registration Code
            </Label>
            <Input
              name="legal_unique_registration_code"
              id="legal_unique_registration_code-field"
              className="form-control"
              placeholder="Enter Unique Registration Code"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.legal_unique_registration_code || ""}
              invalid={
                validation.touched.legal_unique_registration_code &&
                validation.errors.legal_unique_registration_code
                  ? true
                  : false
              }
            />
            {validation.touched.legal_unique_registration_code &&
              validation.errors.legal_unique_registration_code && (
                <FormFeedback type="invalid">
                  {validation.errors.legal_unique_registration_code}
                </FormFeedback>
              )}
          </div>

          <div className="col-md-6">
            <Label
              htmlFor="legal_trade_register_number-field"
              className="form-label"
            >
              Trade Register Number
            </Label>
            <Input
              name="legal_trade_register_number"
              id="legal_trade_register_number-field"
              className="form-control"
              placeholder="Enter Trade Register Number"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.legal_trade_register_number || ""}
              invalid={
                validation.touched.legal_trade_register_number &&
                validation.errors.legal_trade_register_number
                  ? true
                  : false
              }
            />
            {validation.touched.legal_trade_register_number &&
              validation.errors.legal_trade_register_number && (
                <FormFeedback type="invalid">
                  {validation.errors.legal_trade_register_number}
                </FormFeedback>
              )}
          </div>
        </div>
      </div>
      <div className="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          className="btn btn-success btn-label right ms-auto nexttab"
          onClick={() => {
            handleNext();
          }}
        >
          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
          Next
        </button>
      </div>
    </TabPane>
  );

  // Tab 2 - Company Location
  const renderCompanyLocationTab = () => (
    <TabPane id="steparrow-description-info" tabId={2}>
      <div>
        <div className="row gy-4 mb-3">
          <div className="col-md-6">
            <Label htmlFor="legal_country-field" className="form-label">
              Legal Country
            </Label>
            <CountrySelect validation={validation} fieldName="legal_country" />
            {validation.touched.legal_country &&
              validation.errors.legal_country && (
                <div className="invalid-feedback d-block">
                  {validation.errors.legal_country}
                </div>
              )}
          </div>

          <div className="col-md-6">
            <Label htmlFor="legal_region-field" className="form-label">
              Legal Region
            </Label>
            <Input
              name="legal_region"
              id="legal_region-field"
              className="form-control"
              placeholder="Enter Legal Region"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.legal_region || ""}
              invalid={
                validation.touched.legal_region &&
                validation.errors.legal_region
                  ? true
                  : false
              }
            />
            {validation.touched.legal_region &&
              validation.errors.legal_region && (
                <FormFeedback type="invalid">
                  {validation.errors.legal_region}
                </FormFeedback>
              )}
          </div>
        </div>

        <div className="row gy-4 mb-3">
          <div className="col-md-6">
            <Label htmlFor="legal_city-field" className="form-label">
              Legal City
            </Label>
            <Input
              name="legal_city"
              id="legal_city-field"
              className="form-control"
              placeholder="Enter Legal City"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.legal_city || ""}
              invalid={
                validation.touched.legal_city && validation.errors.legal_city
                  ? true
                  : false
              }
            />
            {validation.touched.legal_city && validation.errors.legal_city && (
              <FormFeedback type="invalid">
                {validation.errors.legal_city}
              </FormFeedback>
            )}
          </div>

          <div className="col-md-6">
            <Label htmlFor="legal_office_address-field" className="form-label">
              Legal Office Address
            </Label>
            <Input
              name="legal_office_address"
              id="legal_office_address-field"
              className="form-control"
              placeholder="Enter Legal Office Address"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.legal_office_address || ""}
              invalid={
                validation.touched.legal_office_address &&
                validation.errors.legal_office_address
                  ? true
                  : false
              }
            />
            {validation.touched.legal_office_address &&
              validation.errors.legal_office_address && (
                <FormFeedback type="invalid">
                  {validation.errors.legal_office_address}
                </FormFeedback>
              )}
          </div>
        </div>

        <div className="row gy-4 mb-3">
          <div className="col-md-6">
            <Label htmlFor="mobile_phone_number-field" className="form-label">
              Mobile Phone Number
            </Label>
            <Input
              name="mobile_phone_number"
              id="mobile_phone_number-field"
              className="form-control"
              placeholder="Enter Mobile Phone Number"
              type="text"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              value={validation.values.mobile_phone_number || ""}
              invalid={
                validation.touched.mobile_phone_number &&
                validation.errors.mobile_phone_number
                  ? true
                  : false
              }
            />
            {validation.touched.mobile_phone_number &&
              validation.errors.mobile_phone_number && (
                <FormFeedback type="invalid">
                  {validation.errors.mobile_phone_number}
                </FormFeedback>
              )}
          </div>
          <div className="col-md-6">
            <Label htmlFor="land_phone_number-field" className="form-label">
              Landline Phone Number{" "}
              <span className="text-muted">(optional)</span>
            </Label>
            <Input
              name="land_phone_number"
              id="land_phone_number-field"
              className="form-control"
              placeholder="Enter Landline Phone Number"
              type="text"
              onChange={validation.handleChange}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              onBlur={validation.handleBlur}
              value={validation.values.land_phone_number || ""}
            />
          </div>
        </div>
      </div>

      <div className="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          className="btn btn-light btn-label previestab"
          onClick={() => {
            toggleArrowTab(activeArrowTab - 1);
          }}
        >
          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>
          Back
        </button>
        <button
          type="button"
          className="btn btn-success btn-label right ms-auto nexttab"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleNext();
          }}
        >
          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
          Next
        </button>
      </div>
    </TabPane>
  );

  // Tab 3 - Company Accounts
  const renderCompanyAccountsTab = () => (
    <TabPane id="steparrow-final" tabId={3}>
      <div>
        <div className="row gy-4 mb-3">
          <div className="col-md-6">
            <Label htmlFor="personal_email-field" className="form-label">
              Personal Email <span className="text-muted">(optional)</span>
            </Label>
            <Input
              name="personal_email"
              id="personal_email-field"
              className="form-control"
              placeholder="Enter Personal Email"
              type="email"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.personal_email || ""}
            />
          </div>
          <div className="col-md-6">
            <Label htmlFor="business_email-field" className="form-label">
              Business Email
            </Label>
            <Input
              name="business_email"
              id="business_email-field"
              className="form-control"
              placeholder="Enter Business Email"
              type="email"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.business_email || ""}
              invalid={
                validation.touched.business_email &&
                validation.errors.business_email
                  ? true
                  : false
              }
            />
            {validation.touched.business_email &&
            validation.errors.business_email ? (
              <FormFeedback type="invalid">
                {validation.errors.business_email}
              </FormFeedback>
            ) : null}
          </div>
        </div>

        <div className="mb-3">
          <Label htmlFor="iban_ron-field" className="form-label">
            IBAN (RON) <span className="text-muted">(optional)</span>
          </Label>
          <Input
            name="iban_ron"
            id="iban_ron-field"
            className="form-control"
            placeholder="Enter IBAN (RON)"
            type="text"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.iban_ron || ""}
          />
        </div>

        <div className="mb-3">
          <Label htmlFor="iban_euro-field" className="form-label">
            IBAN (EUR) <span className="text-muted">(optional)</span>
          </Label>
          <Input
            name="iban_euro"
            id="iban_euro-field"
            className="form-control"
            placeholder="Enter IBAN (EUR)"
            type="text"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.iban_euro || ""}
          />
        </div>
      </div>

      <div className="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          className="btn btn-light btn-label previestab"
          onClick={() => {
            toggleArrowTab(activeArrowTab - 1);
          }}
        >
          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>
          Back
        </button>
        <button
          type="submit"
          className="btn btn-success btn-label right ms-auto nexttab nexttab"
        >
          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
          Submit
        </button>
      </div>
    </TabPane>
  );

  switch (activeArrowTab) {
    case 1:
      return renderCompanyDetailsTab();
    case 2:
      return renderCompanyLocationTab();
    case 3:
      return renderCompanyAccountsTab();
    default:
      return null;
  }
};

LegalClientForm.propTypes = {
  activeArrowTab: PropTypes.number.isRequired,
  validation: PropTypes.object.isRequired,
  handleNext: PropTypes.func.isRequired,
  toggleArrowTab: PropTypes.func.isRequired,
};

export default LegalClientForm;
